import { useEffect, useRef } from "react";
import { ExpandingTooltipReturn } from "../hooks/useAdvancedTooltip";
import { useDropdown } from "../hooks/useDropdown";
import Icon from "../Icon";
import "../../styles/panels/modelViewDropdown.css";

export { ModelViewDropdown, View };
type Props = {
  view: View;
  onChange: (value: View) => void;
  tProps?: ExpandingTooltipReturn["triggerProps"];
};
type View = "extraction" | "transformation" | "validation";

const ModelViewDropdown = ({ view, onChange, tProps }: Props) => {
  const containerRef = useRef<HTMLSpanElement | null>(null);
  const nullRef = useRef<HTMLSpanElement | null>(null);

  const { isOpen, renderTooltip, setOpen, triggerBounds, triggerProps } =
    useDropdown({
      // containerRef,
      containerRef: nullRef,
      options: {
        extraction: "Extraction",
        validation: "Validation",
        transformation: "Transformation",
      },
      selected: view,
      onSelect: (val) => {
        onChange(val as View);
        setOpen(false);
      },
    });

  useEffect(() => {
    tProps?.ref(containerRef.current);
  }, [containerRef.current]);

  return (
    <>
      <span
        {...tProps}
        onClick={(e) => {
          setOpen(!isOpen);
          e.stopPropagation();
        }}
        className={"modelViewDropdown"}
        ref={containerRef}
      >
        {view === "extraction" && "Extraction"}
        {view === "transformation" && "Transformation"}
        {view === "validation" && "Validation"}
        <Icon
          {...triggerProps}
          onClick={(e) => {
            setOpen(!isOpen);
            e.stopPropagation();
          }}
          altText={""}
          icon={"chevron-down"}
        />
        {isOpen && renderTooltip()}
      </span>
    </>
  );
};
